var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "row" },
    [
      _c("b-loading", {
        attrs: {
          "is-full-page": _vm.isFullPage,
          active: _vm.isLoading,
          "can-cancel": true
        },
        on: {
          "update:active": function($event) {
            _vm.isLoading = $event
          }
        }
      }),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "sidebar sidebar-fixed bg-white",
          attrs: { id: "sidebarMenu" }
        },
        [
          _c("div", { staticClass: "sidebar-header" }, [
            _c("h5", [_vm._v(" ")]),
            _vm._v(" "),
            _c(
              "a",
              { attrs: { href: "", id: "sidebarMenuClose" } },
              [
                _c("feather", {
                  staticClass:
                    "wd-15 hd-15 mg-r-5 valign-middle-f svg_overflow",
                  attrs: { type: "x" }
                })
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "sidebar-body" }, [
            _vm.properties.uid
              ? _c(
                  "div",
                  [
                    _vm._l(_vm.inputSearchForms, function(form, i) {
                      return form.division === "C"
                        ? _c("ul", { staticClass: "sidebar-nav" }, [
                            i === 0
                              ? _c(
                                  "li",
                                  { staticClass: "nav-label mg-b-10-f" },
                                  [_vm._v(" ")]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c("div", { staticClass: "form-group" }, [
                              _c(
                                "label",
                                {
                                  staticClass: "has-text-weight-semibold",
                                  attrs: { for: form.id }
                                },
                                [
                                  _vm._v(
                                    _vm._s(form.name) + " \n\t\t\t\t\t\t\t\t"
                                  ),
                                  _vm._v(" "),
                                  form.name === "실험명"
                                    ? _c(
                                        "a",
                                        {
                                          staticClass:
                                            "has-text-weight-semibold",
                                          staticStyle: {
                                            "margin-left": "6.5rem"
                                          },
                                          attrs: { href: "#" },
                                          on: { click: _vm.expNameHandler }
                                        },
                                        [_vm._v("IMPORT")]
                                      )
                                    : _vm._e()
                                ]
                              ),
                              _vm._v(" "),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model.lazy",
                                    value: _vm.experimentData[form.id],
                                    expression: "experimentData[form.id]",
                                    modifiers: { lazy: true }
                                  }
                                ],
                                staticClass: "form-control",
                                attrs: {
                                  type: "email",
                                  name: form.id,
                                  id: form.id,
                                  placeholder: form.name
                                },
                                domProps: {
                                  value: _vm.experimentData[form.id]
                                },
                                on: {
                                  keyup: _vm.headerDataChangeHandler,
                                  change: function($event) {
                                    return _vm.$set(
                                      _vm.experimentData,
                                      form.id,
                                      $event.target.value
                                    )
                                  }
                                }
                              })
                            ])
                          ])
                        : form.division === "O"
                        ? _c("ul", { staticClass: "sidebar-nav" }, [
                            i === 0
                              ? _c(
                                  "li",
                                  { staticClass: "nav-label mg-b-10-f" },
                                  [_vm._v(" ")]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c("div", { staticClass: "form-group" }, [
                              _c(
                                "label",
                                {
                                  staticClass:
                                    "d-block has-text-weight-semibold",
                                  attrs: { for: "formGroupExampleInput" }
                                },
                                [_vm._v(_vm._s(form.name))]
                              ),
                              _vm._v(" "),
                              form.value.length > 0
                                ? _c(
                                    "p",
                                    { staticClass: "mg-b-0 text-left" },
                                    _vm._l(form.value, function(form1, i) {
                                      return form1.codeCode ==
                                        _vm.experimentData[form.id]
                                        ? _c("span", [
                                            _vm._v(_vm._s(form1.codeName))
                                          ])
                                        : _vm._e()
                                    }),
                                    0
                                  )
                                : _c("p", { staticClass: "mg-b-0 text-left" }, [
                                    _vm._v(_vm._s(_vm.experimentData[form.id]))
                                  ])
                            ])
                          ])
                        : _vm._e()
                    }),
                    _vm._v(" "),
                    _vm._l(_vm.checkboxSearchForms, function(form, i) {
                      return _c("ul", { staticClass: "sidebar-nav" }, [
                        _c(
                          "div",
                          { staticClass: "form-group" },
                          [
                            _c(
                              "label",
                              {
                                staticClass:
                                  " d-block has-text-weight-semibold",
                                attrs: { for: "formGroupExampleInput" }
                              },
                              [_vm._v(_vm._s(form.name))]
                            ),
                            _vm._v(" "),
                            _vm._l(form.value, function(form1, i) {
                              return _c(
                                "div",
                                {
                                  staticClass:
                                    "ml-2 custom-control custom-radio mb-1"
                                },
                                [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.experimentData[form.id],
                                        expression: "experimentData[form.id]"
                                      }
                                    ],
                                    staticClass: "custom-control-input",
                                    attrs: {
                                      type: "radio",
                                      id: form1.codeCode,
                                      name: form.id
                                    },
                                    domProps: {
                                      value: form1.codeCode,
                                      checked:
                                        form1.codeCode ==
                                        _vm.experimentData[form.id],
                                      checked: _vm._q(
                                        _vm.experimentData[form.id],
                                        form1.codeCode
                                      )
                                    },
                                    on: {
                                      keyup: _vm.headerDataChangeHandler,
                                      change: function($event) {
                                        return _vm.$set(
                                          _vm.experimentData,
                                          form.id,
                                          form1.codeCode
                                        )
                                      }
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "label",
                                    {
                                      staticClass: "custom-control-label",
                                      attrs: { for: form1.codeCode }
                                    },
                                    [_vm._v(_vm._s(form1.codeName))]
                                  )
                                ]
                              )
                            })
                          ],
                          2
                        )
                      ])
                    }),
                    _vm._v(" "),
                    _vm._l(_vm.dateRangeSearchForms, function(form, i) {
                      return _c("ul", { staticClass: "sidebar-nav" }, [
                        _c("div", { staticClass: "form-group" }, [
                          _c(
                            "label",
                            {
                              staticClass: "d-block has-text-weight-semibold",
                              attrs: { for: "formGroupExampleInput" }
                            },
                            [_vm._v(_vm._s(form.name))]
                          ),
                          _vm._v(" "),
                          _c(
                            "li",
                            { staticClass: "nav-item" },
                            [
                              _c("date-picker", {
                                staticClass: "form-control",
                                attrs: {
                                  config: _vm.datePickerOptions,
                                  autocomplete: "off",
                                  placeholder: "From date",
                                  id: form.fid,
                                  "aria-label": "Search",
                                  ignoreReadonly: ""
                                },
                                on: {
                                  "dp-change": _vm.headerDataChangeHandler
                                },
                                model: {
                                  value: _vm.experimentData[form.fid],
                                  callback: function($$v) {
                                    _vm.$set(_vm.experimentData, form.fid, $$v)
                                  },
                                  expression: "experimentData[form.fid]"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "li",
                            { staticClass: "nav-item" },
                            [
                              _c("date-picker", {
                                staticClass: "form-control",
                                attrs: {
                                  config: _vm.datePickerOptions,
                                  autocomplete: "off",
                                  placeholder: "To date",
                                  id: form.eid,
                                  "aria-label": "Search",
                                  ignoreReadonly: ""
                                },
                                on: {
                                  "dp-change": _vm.headerDataChangeHandler
                                },
                                model: {
                                  value: _vm.experimentData[form.eid],
                                  callback: function($$v) {
                                    _vm.$set(_vm.experimentData, form.eid, $$v)
                                  },
                                  expression: "experimentData[form.eid]"
                                }
                              })
                            ],
                            1
                          )
                        ])
                      ])
                    }),
                    _vm._v(" "),
                    _vm._l(_vm.dateSearchForms, function(form, i) {
                      return _c("ul", { staticClass: "sidebar-nav" }, [
                        _c(
                          "div",
                          { staticClass: "form-group" },
                          [
                            _c(
                              "label",
                              {
                                staticClass: "d-block has-text-weight-semibold",
                                attrs: { for: "formGroupExampleInput" }
                              },
                              [_vm._v(_vm._s(form.name))]
                            ),
                            _vm._v(" "),
                            _c("date-picker", {
                              staticClass: "form-control",
                              attrs: {
                                config: _vm.datePickerOptions,
                                autocomplete: "off",
                                placeholder: form.name,
                                id: form.id,
                                "aria-label": "Search",
                                ignoreReadonly: ""
                              },
                              on: { "dp-change": _vm.headerDataChangeHandler },
                              model: {
                                value: _vm.experimentData[form.id],
                                callback: function($$v) {
                                  _vm.$set(_vm.experimentData, form.id, $$v)
                                },
                                expression: "experimentData[form.id]"
                              }
                            })
                          ],
                          1
                        )
                      ])
                    })
                  ],
                  2
                )
              : _c(
                  "div",
                  [
                    _vm._l(_vm.inputSearchForms, function(form, i) {
                      return form.division === "C"
                        ? _c("ul", { staticClass: "sidebar-nav" }, [
                            i === 0
                              ? _c(
                                  "li",
                                  { staticClass: "nav-label mg-b-10-f" },
                                  [_vm._v(" ")]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c("div", { staticClass: "form-group" }, [
                              _c(
                                "label",
                                {
                                  staticClass: "has-text-weight-semibold",
                                  attrs: { for: form.id }
                                },
                                [
                                  _vm._v(
                                    _vm._s(form.name) + " \n\t\t\t\t\t\t\t\t"
                                  ),
                                  _vm._v(" "),
                                  form.name == "실험명"
                                    ? _c(
                                        "a",
                                        {
                                          staticClass:
                                            "has-text-weight-semibold",
                                          staticStyle: {
                                            "margin-left": "6.5rem"
                                          },
                                          attrs: { href: "#" },
                                          on: { click: _vm.expNameHandler }
                                        },
                                        [_vm._v("IMPORT")]
                                      )
                                    : _vm._e()
                                ]
                              ),
                              _vm._v(" "),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model.lazy",
                                    value: _vm.experimentData[form.id],
                                    expression: "experimentData[form.id]",
                                    modifiers: { lazy: true }
                                  }
                                ],
                                staticClass: "form-control",
                                attrs: {
                                  type: "email",
                                  name: form.id,
                                  id: form.id,
                                  placeholder: form.name
                                },
                                domProps: {
                                  value: _vm.experimentData[form.id]
                                },
                                on: {
                                  keyup: _vm.headerDataChangeHandler,
                                  change: function($event) {
                                    return _vm.$set(
                                      _vm.experimentData,
                                      form.id,
                                      $event.target.value
                                    )
                                  }
                                }
                              })
                            ])
                          ])
                        : _vm._e()
                    }),
                    _vm._v(" "),
                    _vm._l(_vm.dateRangeSearchForms, function(form, i) {
                      return _c("ul", { staticClass: "sidebar-nav" }, [
                        _c("div", { staticClass: "form-group" }, [
                          _c(
                            "label",
                            {
                              staticClass: "d-block has-text-weight-semibold",
                              attrs: { for: "formGroupExampleInput" }
                            },
                            [_vm._v(_vm._s(form.name))]
                          ),
                          _vm._v(" "),
                          _c(
                            "li",
                            { staticClass: "nav-item" },
                            [
                              _c("date-picker", {
                                staticClass: "form-control",
                                attrs: {
                                  config: _vm.datePickerOptions,
                                  autocomplete: "off",
                                  placeholder: "From date",
                                  id: form.fid,
                                  "aria-label": "Search",
                                  ignoreReadonly: ""
                                },
                                on: {
                                  "dp-change": _vm.headerDataChangeHandler
                                },
                                model: {
                                  value: _vm.experimentData[form.fid],
                                  callback: function($$v) {
                                    _vm.$set(_vm.experimentData, form.fid, $$v)
                                  },
                                  expression: "experimentData[form.fid]"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "li",
                            { staticClass: "nav-item" },
                            [
                              _c("date-picker", {
                                staticClass: "form-control",
                                attrs: {
                                  config: _vm.datePickerOptions,
                                  autocomplete: "off",
                                  placeholder: "To date",
                                  id: form.eid,
                                  "aria-label": "Search",
                                  ignoreReadonly: ""
                                },
                                on: {
                                  "dp-change": _vm.headerDataChangeHandler
                                },
                                model: {
                                  value: _vm.experimentData[form.eid],
                                  callback: function($$v) {
                                    _vm.$set(_vm.experimentData, form.eid, $$v)
                                  },
                                  expression: "experimentData[form.eid]"
                                }
                              })
                            ],
                            1
                          )
                        ])
                      ])
                    }),
                    _vm._v(" "),
                    _vm._l(_vm.dateSearchForms, function(form, i) {
                      return form.division === "C"
                        ? _c("ul", { staticClass: "sidebar-nav" }, [
                            i === 0
                              ? _c(
                                  "li",
                                  { staticClass: "nav-label mg-b-10-f" },
                                  [_vm._v(" ")]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "form-group" },
                              [
                                _c(
                                  "label",
                                  {
                                    staticClass: "has-text-weight-semibold",
                                    attrs: { for: form.id }
                                  },
                                  [
                                    _vm._v(_vm._s(form.name) + " "),
                                    form.division === "C" && form.attr
                                      ? _c(
                                          "span",
                                          {
                                            staticClass:
                                              "tx-danger has-text-weight-semibold"
                                          },
                                          [_vm._v("*")]
                                        )
                                      : _vm._e()
                                  ]
                                ),
                                _vm._v(" "),
                                _c("date-picker", {
                                  staticClass: "form-control",
                                  attrs: {
                                    config: _vm.datePickerOptions,
                                    autocomplete: "off",
                                    placeholder: form.name,
                                    id: form.id,
                                    "aria-label": "Search",
                                    ignoreReadonly: ""
                                  },
                                  on: {
                                    "dp-change": _vm.headerDataChangeHandler
                                  },
                                  model: {
                                    value: _vm.experimentData[form.id],
                                    callback: function($$v) {
                                      _vm.$set(_vm.experimentData, form.id, $$v)
                                    },
                                    expression: "experimentData[form.id]"
                                  }
                                })
                              ],
                              1
                            )
                          ])
                        : _vm._e()
                    })
                  ],
                  2
                ),
            _vm._v(" "),
            _vm._m(0),
            _vm._v(" "),
            _c(
              "div",
              [
                _c("imgUpload", { on: { imgFileHandler: this.imgFileHandler } })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "card card-body p-1 paste-background-color" },
              [
                _c("input", {
                  staticClass: "img-input paste-background-color",
                  attrs: {
                    type: "text",
                    multiple: "multiple",
                    placeholder: "Paste your images here"
                  },
                  on: { paste: _vm.onPaste }
                }),
                _vm._v(" "),
                _c("img", { attrs: { id: "pasteImg" } }),
                _vm._v(" "),
                _c("p", { staticClass: "m-0", attrs: { id: "countPasteImg" } })
              ]
            ),
            _vm._v(" "),
            _vm._m(1),
            _vm._v(" "),
            _c(
              "div",
              [
                _c("nanoUpload", {
                  on: { nanoFileHandler: this.nanoFileHandler }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "card card-body p-1 paste-background-color" },
              [
                _c("input", {
                  staticClass: "img-input paste-background-color",
                  attrs: {
                    type: "text",
                    multiple: "multiple",
                    placeholder: "Paste your images here"
                  },
                  on: { paste: _vm.onNanoPaste }
                }),
                _vm._v(" "),
                _c("img", { attrs: { id: "pasteNano" } }),
                _vm._v(" "),
                _c("p", { staticClass: "m-0", attrs: { id: "countPasteNano" } })
              ]
            ),
            _vm._v(" "),
            _vm.menuStatus == "04000"
              ? _c(
                  "div",
                  { staticStyle: { "margin-top": "10px" } },
                  [
                    _vm._m(2),
                    _vm._v(" "),
                    _c("tapeUpload", {
                      on: { tapeFileHandler: this.tapeFileHandler }
                    })
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.menuStatus == "04000"
              ? _c(
                  "div",
                  { staticStyle: { "margin-top": "10px" } },
                  [
                    _vm._m(3),
                    _vm._v(" "),
                    _c("bioUpload", {
                      on: { bioFileHandler: this.bioFileHandler }
                    })
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm._m(4),
            _vm._v(" "),
            _c(
              "div",
              [
                _c("pdfUpload", { on: { pdfFileHandler: this.pdfFileHandler } })
              ],
              1
            )
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "content content-components pd-b-0-f overflow-hidden" },
        [
          _c("div", { staticClass: "pd-x-0 pd-lg-x-10 pd-xl-x-0" }, [
            _c(
              "div",
              {
                staticClass:
                  "d-sm-flex align-items-center justify-content-between"
              },
              [
                _c("div", [
                  _c("nav", { attrs: { "aria-label": "breadcrumb" } }, [
                    _c(
                      "ol",
                      { staticClass: "breadcrumb breadcrumb-style1 mg-b-10" },
                      [
                        _c("li", { staticClass: "breadcrumb-item" }, [
                          _vm._v(_vm._s(this.mainName))
                        ]),
                        _vm._v(" "),
                        _c(
                          "li",
                          {
                            staticClass: "breadcrumb-item",
                            attrs: { "aria-current": "page" }
                          },
                          [_vm._v(_vm._s(this.subName))]
                        ),
                        _vm._v(" "),
                        _c(
                          "li",
                          {
                            staticClass: "breadcrumb-item active",
                            attrs: { "aria-current": "page" }
                          },
                          [_vm._v("Detail")]
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c("h4", { staticClass: "mg-b-0 tx-spacing--1" }, [
                      _vm._v(_vm._s(this.subName) + " Detail")
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "card-header2 col-lg-8 col-xl-7 pd-y-15 pd-x-20 d-flex align-items-center justify-content-end"
                  },
                  [
                    _c(
                      "button",
                      {
                        staticClass:
                          "btn btn-sm pd-x-15 btn-primary btn-uppercase mg-l-5",
                        on: {
                          click: function($event) {
                            return _vm.reportEditor()
                          }
                        }
                      },
                      [
                        _c("feather", {
                          staticClass:
                            "wd-15 hd-15 mg-r-5 valign-middle-f svg_overflow",
                          attrs: { type: "printer" }
                        }),
                        _vm._v("Report")
                      ],
                      1
                    ),
                    _vm._v(" "),
                    !_vm.appButtonFlag && _vm.properties.uid
                      ? _c(
                          "button",
                          {
                            staticClass:
                              "btn btn-sm pd-x-15 btn-primary btn-uppercase mg-l-5-f",
                            on: {
                              click: function($event) {
                                return _vm.approval()
                              }
                            }
                          },
                          [
                            _c("feather", {
                              staticClass:
                                "wd-15 hd-15 mg-r-5 valign-middle-f svg_overflow",
                              attrs: { type: "user-check" }
                            }),
                            _vm._v("Approval")
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.appButtonFlag
                      ? _c(
                          "button",
                          {
                            staticClass:
                              "btn btn-sm pd-x-15 btn-primary btn-uppercase mg-l-5-f",
                            on: {
                              click: function($event) {
                                return _vm.confirmData()
                              }
                            }
                          },
                          [
                            _c("feather", {
                              staticClass:
                                "wd-15 hd-15 mg-r-5 valign-middle-f svg_overflow",
                              attrs: { type: "folder" }
                            }),
                            _vm._v("Confirm")
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass:
                          "btn btn-sm pd-x-15 btn-primary btn-uppercase mg-l-5-f",
                        on: {
                          click: function($event) {
                            return _vm.createData(true, "create")
                          }
                        }
                      },
                      [
                        _c("feather", {
                          staticClass:
                            "wd-15 hd-15 mg-r-5 valign-middle-f svg_overflow",
                          attrs: { type: "folder" }
                        }),
                        _vm._v("Save")
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm.properties.uid
                      ? _c(
                          "button",
                          {
                            staticClass:
                              "btn btn-sm pd-x-15 btn-primary btn-uppercase mg-l-5-f",
                            on: {
                              click: function($event) {
                                return _vm.deleteData()
                              }
                            }
                          },
                          [
                            _c("feather", {
                              staticClass:
                                "wd-15 hd-15 mg-r-5 valign-middle-f svg_overflow",
                              attrs: { type: "delete" }
                            }),
                            _vm._v("delete")
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass:
                          "btn btn-sm pd-x-15 btn-primary btn-uppercase mg-l-5-f",
                        on: {
                          click: function($event) {
                            return _vm.goPage()
                          }
                        }
                      },
                      [
                        _c("feather", {
                          staticClass:
                            "wd-15 hd-15 mg-r-5 valign-middle-f svg_overflow",
                          attrs: { type: "file" }
                        }),
                        _vm._v("List")
                      ],
                      1
                    )
                  ]
                )
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: " pd-x-0 pd-lg-x-10 pd-xl-x-0" }, [
              _c("div", { staticClass: "col-sm-6 col-lg-5 d-inline-block" }, [
                _c(
                  "ul",
                  {
                    staticClass: "cardborder nav nav-tabs",
                    attrs: { id: "myTab", role: "tablist" }
                  },
                  [
                    _c("li", { staticClass: "nav-item" }, [
                      _c(
                        "a",
                        {
                          staticClass: "nav-link active",
                          attrs: {
                            id: "experiment-tab",
                            "data-toggle": "tab",
                            href: "#experiment",
                            role: "tab",
                            "aria-controls": "experiment",
                            "aria-selected": "true"
                          },
                          on: {
                            click: function($event) {
                              return _vm.rendertab()
                            }
                          }
                        },
                        [_vm._v("Experiment")]
                      )
                    ]),
                    _vm._v(" "),
                    _vm._m(5)
                  ]
                )
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "d-inline-block",
                  staticStyle: {
                    "max-width": "57%",
                    width: "100%",
                    "text-align": "right"
                  }
                },
                [
                  this.downloadList.QC.length > 0
                    ? _c(
                        "button",
                        {
                          staticClass:
                            "btn btn-xs pd-x-15 btn-info btn-uppercase mg-l-5-f",
                          on: {
                            click: function($event) {
                              return _vm.reportDialogHandler()
                            }
                          }
                        },
                        [
                          _c("feather", {
                            staticClass:
                              "wd-15 hd-15 mg-r-5 valign-middle-f svg_overflow",
                            attrs: { type: "file-text" }
                          }),
                          _vm._v("QC_Report")
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.imgData.length > 0
                    ? _c(
                        "button",
                        {
                          staticClass:
                            "btn btn-xs pd-x-15 btn-info btn-uppercase mg-l-5-f",
                          attrs: {
                            "data-toggle": "collapse",
                            "data-target": "#ViewGel"
                          }
                        },
                        [
                          _c("feather", {
                            staticClass:
                              "wd-15 hd-15 mg-r-5 valign-middle-f svg_overflow",
                            attrs: { type: "image" }
                          }),
                          _vm._v("Gel")
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", { staticClass: "gel-container" }, [
                    _c("div", { staticClass: "row" }, [
                      _c("div", { staticClass: "cart" }, [
                        _c(
                          "div",
                          {
                            directives: [
                              { name: "draggable", rawName: "v-draggable" }
                            ],
                            staticClass: "items-list collapse",
                            staticStyle: { "max-width": "1500px" },
                            style: {
                              width:
                                _vm.imgData.length * 180 +
                                _vm.imgData.length * 20 +
                                "px"
                            },
                            attrs: { id: "ViewGel" }
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "viewer-scroll",
                                staticStyle: {
                                  "white-space": "nowrap",
                                  "overflow-x": "scroll"
                                }
                              },
                              [
                                _c("imageViewer", {
                                  attrs: { image: _vm.imgData },
                                  on: { deleteImgFile: this.deleteImgFile }
                                }),
                                _vm._v(" "),
                                _vm._m(6)
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _vm._m(7)
                          ]
                        )
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _vm.nanoData.length > 0
                    ? _c(
                        "button",
                        {
                          staticClass:
                            "btn btn-xs pd-x-15 btn-info btn-uppercase mg-l-5-f",
                          attrs: {
                            "data-toggle": "collapse",
                            "data-target": "#ViewNano"
                          }
                        },
                        [
                          _c("nanoIcon", {
                            staticClass: "wd-15 hd-15 mg-r-5 ",
                            attrs: { fill: "white" }
                          }),
                          _vm._v("NANO DROP")
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", { staticClass: "gel-container" }, [
                    _c("div", { staticClass: "row" }, [
                      _c("div", { staticClass: "cart" }, [
                        _c(
                          "div",
                          {
                            directives: [
                              { name: "draggable", rawName: "v-draggable" }
                            ],
                            staticClass: "items-list collapse",
                            staticStyle: { "max-width": "1500px" },
                            style: {
                              width:
                                _vm.nanoData.length * 180 +
                                _vm.nanoData.length * 20 +
                                "px"
                            },
                            attrs: { id: "ViewNano" }
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "viewer-scroll",
                                staticStyle: {
                                  "white-space": "nowrap",
                                  "overflow-x": "scroll"
                                }
                              },
                              [
                                _c("imageViewerNano", {
                                  attrs: { image: _vm.nanoData },
                                  on: { deleteImgFile: this.deleteImgFile }
                                }),
                                _vm._v(" "),
                                _vm._m(8)
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _vm._m(9)
                          ]
                        )
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _vm.tapeData.length > 0
                    ? _c(
                        "button",
                        {
                          staticClass:
                            "btn btn-xs pd-x-15 btn-info btn-uppercase mg-l-5-f",
                          attrs: {
                            "data-toggle": "collapse",
                            "data-target": "#ViewTape"
                          }
                        },
                        [
                          _c("tapeIcon", {
                            staticClass: "wd-15 hd-15 mg-r-5 ",
                            attrs: { fill: "white" }
                          }),
                          _vm._v("TAPE STATION")
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", { staticClass: "tape-container" }, [
                    _c("div", { staticClass: "row" }, [
                      _c("div", { staticClass: "cart" }, [
                        _c(
                          "div",
                          {
                            directives: [
                              { name: "draggable", rawName: "v-draggable" }
                            ],
                            staticClass: "items-list2 collapse viewer-scroll",
                            attrs: { id: "ViewTape" }
                          },
                          [
                            _c("imageViewerTape", {
                              attrs: { image: _vm.tapeData },
                              on: { deleteTapeFile: this.deleteTapeFile }
                            }),
                            _vm._v(" "),
                            _vm._m(10),
                            _vm._v(" "),
                            _vm._m(11),
                            _vm._v(" "),
                            _vm._m(12)
                          ],
                          1
                        )
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _vm.bioData.length > 0
                    ? _c(
                        "button",
                        {
                          staticClass:
                            "btn btn-xs pd-x-15 btn-info btn-uppercase mg-l-5-f",
                          attrs: {
                            "data-toggle": "collapse",
                            "data-target": "#ViewBio"
                          }
                        },
                        [
                          _c("tapeIcon", {
                            staticClass: "wd-15 hd-15 mg-r-5 ",
                            attrs: { fill: "white" }
                          }),
                          _vm._v("BIO ANALYZER")
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", { staticClass: "tape-container" }, [
                    _c("div", { staticClass: "row" }, [
                      _c("div", { staticClass: "cart" }, [
                        _c(
                          "div",
                          {
                            directives: [
                              { name: "draggable", rawName: "v-draggable" }
                            ],
                            staticClass: "items-list2 collapse viewer-scroll",
                            attrs: { id: "ViewBio" }
                          },
                          [
                            _c("imageViewerBio", {
                              attrs: { image: _vm.bioData },
                              on: { deleteBioFile: this.deleteBioFile }
                            }),
                            _vm._v(" "),
                            _vm._m(13),
                            _vm._v(" "),
                            _vm._m(14),
                            _vm._v(" "),
                            _vm._m(15)
                          ],
                          1
                        )
                      ])
                    ])
                  ])
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "card card-body pd-b-0-f" }, [
                _c(
                  "div",
                  { staticClass: "tab-content", attrs: { id: "myTabContent" } },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "tab-pane fade lm-overflow show active",
                        attrs: {
                          id: "experiment",
                          role: "tabpanel",
                          "aria-labelledby": "experiment-tab"
                        }
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "d-none d-md-block tx-right-f" },
                          [
                            _c(
                              "a",
                              {
                                staticClass:
                                  "btn btn-xs pd-x-15 btn-secondary btn-uppercase mg-l-5 is-pulled-left",
                                attrs: {
                                  href: "",
                                  "data-toggle": "modal",
                                  "data-animation": "effect-flip-horizontal"
                                },
                                on: { click: this.checkAll }
                              },
                              [
                                _c("feather", {
                                  staticClass:
                                    "wd-15 hd-15 mg-r-5 valign-middle-f svg_overflow",
                                  attrs: { type: "check" }
                                }),
                                _vm._v("all checked")
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _vm.firstExpBool
                              ? _c(
                                  "a",
                                  {
                                    staticClass:
                                      "btn btn-xs pd-x-15 btn-secondary btn-uppercase mg-l-5",
                                    attrs: {
                                      href: "#modal6",
                                      "data-toggle": "modal",
                                      "data-animation": "effect-flip-horizontal"
                                    }
                                  },
                                  [
                                    _c("feather", {
                                      staticClass:
                                        "wd-15 hd-15 mg-r-5 valign-middle-f svg_overflow",
                                      attrs: { type: "minus" }
                                    }),
                                    _vm._v("division")
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "a",
                              {
                                staticClass:
                                  "btn btn-xs pd-x-15 btn-secondary btn-uppercase mg-l-5",
                                attrs: {
                                  href: "",
                                  "data-toggle": "modal",
                                  "data-animation": "effect-flip-horizontal"
                                },
                                on: { click: this.sampleDelColumn }
                              },
                              [
                                _c("feather", {
                                  staticClass:
                                    "wd-15 hd-15 mg-r-5 valign-middle-f svg_overflow",
                                  attrs: { type: "minus" }
                                }),
                                _vm._v("delete")
                              ],
                              1
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "ul",
                          {
                            staticClass: "nav nav-line mg-b-0-f",
                            attrs: { id: "myTab5", role: "tablist" }
                          },
                          _vm._l(_vm.tabHeader, function(form, i) {
                            return _vm.properties.mid === form.id
                              ? _c("li", { staticClass: "nav-item" }, [
                                  _c(
                                    "a",
                                    {
                                      staticClass: "nav-link active",
                                      attrs: {
                                        id: form.id,
                                        "data-toggle": "tab",
                                        href: "#",
                                        role: "tab",
                                        "aria-controls": "home",
                                        "aria-selected": "true"
                                      },
                                      on: { click: _vm.classifySampleHeader }
                                    },
                                    [_vm._v(_vm._s(form.menuName))]
                                  )
                                ])
                              : _c("li", { staticClass: "nav-item" }, [
                                  _c(
                                    "a",
                                    {
                                      staticClass: "nav-link",
                                      attrs: {
                                        id: form.id,
                                        "data-toggle": "tab",
                                        href: "#",
                                        role: "tab",
                                        "aria-controls": "profile",
                                        "aria-selected": "false"
                                      },
                                      on: { click: _vm.classifySampleHeader }
                                    },
                                    [_vm._v(_vm._s(form.menuName))]
                                  )
                                ])
                          }),
                          0
                        ),
                        _vm._v(" "),
                        _c("hot-table", {
                          ref: "sheet",
                          staticClass: "ht-hot-table zero-index",
                          attrs: {
                            id: "sample-table",
                            settings: _vm.sheetSettings,
                            data: _vm.sampleData,
                            afterChange: _vm.changeData
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "tab-pane fade",
                        attrs: {
                          id: "samples",
                          role: "tabpanel",
                          "aria-labelledby": "samples-tab"
                        }
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "d-none d-md-block tx-right-f" },
                          [
                            _c(
                              "a",
                              {
                                staticClass:
                                  "btn btn-xs pd-x-15 btn-secondary btn-uppercase mg-l-5",
                                attrs: {
                                  href: "",
                                  "data-toggle": "modal",
                                  "data-animation": "effect-flip-horizontal"
                                },
                                on: { click: _vm.sampleAddColumn }
                              },
                              [
                                _c("feather", {
                                  staticClass:
                                    "wd-15 hd-15 mg-r-5 valign-middle-f svg_overflow",
                                  attrs: { type: "plus" }
                                }),
                                _vm._v("Add")
                              ],
                              1
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "ul",
                          {
                            staticClass: "nav nav-line mg-b-0-f",
                            attrs: { id: "myTab5", role: "tablist" }
                          },
                          _vm._l(_vm.tabHeader, function(form, i) {
                            return _vm.tabHeader.length - 2 === i
                              ? _c("li", { staticClass: "nav-item" }, [
                                  _c(
                                    "a",
                                    {
                                      staticClass: "nav-link active",
                                      attrs: {
                                        id: form.id,
                                        "data-toggle": "tab",
                                        href: "#",
                                        role: "tab",
                                        "aria-controls": "home",
                                        "aria-selected": "true"
                                      },
                                      on: {
                                        click: function($event) {
                                          return _vm.classifyWorkChange(form.id)
                                        }
                                      }
                                    },
                                    [_vm._v(_vm._s(form.menuName))]
                                  )
                                ])
                              : _vm._e()
                          }),
                          0
                        ),
                        _vm._v(" "),
                        _c(
                          "section",
                          [
                            _c(
                              "b-table",
                              {
                                ref: "table",
                                attrs: {
                                  id: "preTable",
                                  data: _vm.isEmpty ? [] : _vm.preData,
                                  "checked-rows": _vm.checkedRows,
                                  striped: "",
                                  checkable: "",
                                  detailed: "",
                                  paginated: "",
                                  "per-page": "40",
                                  "detail-key": "id",
                                  "show-detail-icon": false,
                                  "opened-detailed": _vm.defaultOpenedDetails
                                },
                                on: {
                                  "update:checkedRows": function($event) {
                                    _vm.checkedRows = $event
                                  },
                                  "update:checked-rows": function($event) {
                                    _vm.checkedRows = $event
                                  },
                                  "details-open": function(row, index) {
                                    return _vm.closeAllOtherToggle(row, index)
                                  }
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function(props) {
                                      return _vm._l(_vm.preHeader, function(
                                        form,
                                        i
                                      ) {
                                        return Number(i) == 0
                                          ? _c(
                                              "b-table-column",
                                              {
                                                key: form.id,
                                                attrs: {
                                                  "custom-key": form.id,
                                                  field: "no",
                                                  label: "No",
                                                  centered: ""
                                                }
                                              },
                                              [_vm._v(_vm._s(props.row.no))]
                                            )
                                          : Number(i) == 1
                                          ? _c(
                                              "b-table-column",
                                              {
                                                key: form.id,
                                                attrs: {
                                                  "custom-key": form.id,
                                                  field: form.columnCode,
                                                  label: form.columnName,
                                                  centered: ""
                                                }
                                              },
                                              [
                                                _c(
                                                  "a",
                                                  {
                                                    attrs: {
                                                      href: "#",
                                                      id: props.index
                                                    },
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.toggle(
                                                          props.row
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          props.row[
                                                            form.columnCode
                                                          ]
                                                        ) +
                                                        " "
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                          : _c(
                                              "b-table-column",
                                              {
                                                key: form.id,
                                                attrs: {
                                                  "custom-key": form.id,
                                                  field: form.columnCode,
                                                  label: form.columnName,
                                                  centered: ""
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    props.row[form.columnCode]
                                                  )
                                                )
                                              ]
                                            )
                                      })
                                    }
                                  },
                                  {
                                    key: "detail",
                                    fn: function(props) {
                                      return [
                                        _c(
                                          "ul",
                                          {
                                            staticClass: "nav nav-line",
                                            attrs: {
                                              id: "myTab5",
                                              role: "tablist"
                                            }
                                          },
                                          _vm._l(_vm.tabHeader, function(
                                            form,
                                            i
                                          ) {
                                            return form.id == _vm.re_expid
                                              ? _c(
                                                  "li",
                                                  { staticClass: "nav-item" },
                                                  [
                                                    _c(
                                                      "a",
                                                      {
                                                        staticClass:
                                                          "nav-link active",
                                                        attrs: {
                                                          id: form.id,
                                                          "data-toggle": "tab",
                                                          href: "#",
                                                          role: "tab",
                                                          "aria-controls":
                                                            "home",
                                                          "aria-selected":
                                                            "true"
                                                        },
                                                        on: {
                                                          click:
                                                            _vm.classifyPreSampleHeader
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(form.menuName)
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                )
                                              : _vm.re_expid.length == 0 &&
                                                i == _vm.tabHeader.length - 2
                                              ? _c(
                                                  "li",
                                                  { staticClass: "nav-item" },
                                                  [
                                                    _c(
                                                      "a",
                                                      {
                                                        staticClass:
                                                          "nav-link active",
                                                        attrs: {
                                                          id: form.id,
                                                          "data-toggle": "tab",
                                                          href: "#",
                                                          role: "tab",
                                                          "aria-controls":
                                                            "home",
                                                          "aria-selected":
                                                            "false"
                                                        },
                                                        on: {
                                                          click:
                                                            _vm.classifyPreSampleHeader
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(form.menuName)
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                )
                                              : _vm.tabHeader.length - 2 >= i
                                              ? _c(
                                                  "li",
                                                  { staticClass: "nav-item" },
                                                  [
                                                    _c(
                                                      "a",
                                                      {
                                                        staticClass: "nav-link",
                                                        attrs: {
                                                          id: form.id,
                                                          "data-toggle": "tab",
                                                          href: "#",
                                                          role: "tab",
                                                          "aria-controls":
                                                            "home",
                                                          "aria-selected":
                                                            "false"
                                                        },
                                                        on: {
                                                          click:
                                                            _vm.classifyPreSampleHeader
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(form.menuName)
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                )
                                              : _vm._e()
                                          }),
                                          0
                                        ),
                                        _vm._v(" "),
                                        _c("b-table", {
                                          ref: "preSampleTable",
                                          attrs: {
                                            id: "preSampleTable",
                                            columns: _vm.preSampleHeader,
                                            data: _vm.isEmpty
                                              ? []
                                              : _vm.preSampleData,
                                            "checked-rows":
                                              _vm.sampleCheckedRows,
                                            hoverable: "",
                                            striped: "",
                                            checkable: ""
                                          },
                                          on: {
                                            "update:checkedRows": function(
                                              $event
                                            ) {
                                              _vm.sampleCheckedRows = $event
                                            },
                                            "update:checked-rows": function(
                                              $event
                                            ) {
                                              _vm.sampleCheckedRows = $event
                                            }
                                          }
                                        })
                                      ]
                                    }
                                  }
                                ])
                              },
                              [
                                _vm._v(" "),
                                _c("template", { slot: "empty" }, [
                                  _c("section", { staticClass: "section" }, [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "content has-text-grey has-text-centered"
                                      },
                                      [_c("p", [_vm._v("Nothing here.")])]
                                    )
                                  ])
                                ])
                              ],
                              2
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "d-none" },
                              [
                                _c("b-table", {
                                  ref: "sampleTable",
                                  attrs: { id: "preSampleTable" }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ]
                    )
                  ]
                )
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "df-settings",
                  class: { show: _vm.b_sh_well, "": !_vm.b_sh_well }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass:
                        "df-settings-link closed-cursor text-vertical-3",
                      on: {
                        click: function($event) {
                          return _vm.ptshow()
                        }
                      }
                    },
                    [_vm._v("PLATE")]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "df-settings-body" }, [
                    _c("div", { staticClass: "card card-body" }, [
                      _c(
                        "div",
                        { staticClass: "mg-t-10 mg-sm-t-0" },
                        [
                          _c(
                            "h6",
                            {
                              staticClass:
                                "tx-uppercase tx-11 tx-spacing-1 tx-color-02 tx-semibold mg-b-0-f"
                            },
                            [_vm._v("Plate Well")]
                          ),
                          _vm._v(" "),
                          _vm._l(_vm.well_plate, function(idx) {
                            return _c(
                              "div",
                              {
                                staticClass: "d-none",
                                attrs: { id: "d-idx-" + idx }
                              },
                              [
                                _c(
                                  "ul",
                                  { staticClass: "plate-board" },
                                  [
                                    _c(
                                      "li",
                                      {
                                        staticClass:
                                          "fl tc w1 plate-list2 mg-t-10-f"
                                      },
                                      [_vm._v("(" + _vm._s(idx) + ")")]
                                    ),
                                    _vm._v(" "),
                                    _vm._l(_vm.well_column, function(column) {
                                      return _c(
                                        "li",
                                        {
                                          staticClass:
                                            "fl tc w1 plate-list2 mg-t-10-f"
                                        },
                                        [_vm._v(_vm._s(Number(column)))]
                                      )
                                    })
                                  ],
                                  2
                                ),
                                _vm._v(" "),
                                _vm._l(_vm.well_row, function(row) {
                                  return _c(
                                    "ul",
                                    { staticClass: "plate-board" },
                                    [
                                      _c(
                                        "li",
                                        {
                                          staticClass:
                                            "fl tc plate-w2 plate-list2 pt-sm-2"
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.well_row_a[Number(row) - 1]
                                            )
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          attrs: {
                                            id: "list" + idx + "-" + row
                                          }
                                        },
                                        _vm._l(_vm.well_column, function(
                                          column
                                        ) {
                                          return _c(
                                            "li",
                                            {
                                              staticClass:
                                                "fl tc plate-w2 list1 pt-sm-2",
                                              attrs: {
                                                id:
                                                  _vm.well_row_a[
                                                    Number(row) - 1
                                                  ] + column
                                              }
                                            },
                                            [
                                              _c("div", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.well_row_a[
                                                      Number(row) - 1
                                                    ]
                                                  ) + _vm._s(Number(column))
                                                )
                                              ])
                                            ]
                                          )
                                        }),
                                        0
                                      )
                                    ]
                                  )
                                })
                              ],
                              2
                            )
                          })
                        ],
                        2
                      )
                    ])
                  ])
                ]
              )
            ])
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "modal fade",
          attrs: {
            id: "modal5",
            tabindex: "-1",
            role: "dialog",
            "aria-labelledby": "exampleModalLabel5",
            "aria-hidden": "true"
          }
        },
        [
          _c(
            "div",
            {
              staticClass: "modal-dialog modal-dialog-centered chat-width",
              attrs: { role: "document" }
            },
            [
              _c("div", { staticClass: "modal-content tx-14 chat-height" }, [
                _vm._m(16),
                _vm._v(" "),
                _c("div", { staticClass: "modal-body" }, [_c("Chat")], 1)
              ])
            ]
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "modal fade",
          attrs: {
            id: "modal6",
            tabindex: "-1",
            role: "dialog",
            "aria-labelledby": "exampleModalLabel6",
            "aria-hidden": "true"
          }
        },
        [
          _c(
            "div",
            {
              staticClass: "modal-dialog modal-dialog-centered",
              attrs: { role: "document" }
            },
            [
              _c("div", { staticClass: "modal-content tx-14" }, [
                _vm._m(17),
                _vm._v(" "),
                _vm._m(18),
                _vm._v(" "),
                _c("div", { staticClass: "modal-footer" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-secondary tx-13",
                      attrs: { type: "button", "data-dismiss": "modal" }
                    },
                    [_vm._v("Close")]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-primary tx-13",
                      attrs: { type: "button", "data-dismiss": "modal" },
                      on: {
                        click: function($event) {
                          return _vm.sampleDivision()
                        }
                      }
                    },
                    [_vm._v("Division")]
                  )
                ])
              ])
            ]
          )
        ]
      ),
      _vm._v(" "),
      _c("v-app", { attrs: { id: "inspire" } }, [
        _c(
          "div",
          [
            _c(
              "v-row",
              { attrs: { justify: "center" } },
              [
                _c(
                  "v-dialog",
                  {
                    staticStyle: { "z-index": "20001" },
                    attrs: { "max-width": "500px" },
                    model: {
                      value: _vm.reportDialog,
                      callback: function($$v) {
                        _vm.reportDialog = $$v
                      },
                      expression: "reportDialog"
                    }
                  },
                  [
                    _c(
                      "v-card",
                      [
                        _c("v-card-title", [
                          _vm._v(
                            "\n                            Download Report\n                            "
                          )
                        ]),
                        _vm._v(" "),
                        _c(
                          "v-card-text",
                          [
                            _c("v-select", {
                              attrs: {
                                items: _vm.downloadList["QC"],
                                label: "Select a report",
                                "item-value": "text"
                              },
                              model: {
                                value: _vm.selectReport,
                                callback: function($$v) {
                                  _vm.selectReport = $$v
                                },
                                expression: "selectReport"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "v-card-actions",
                          [
                            _c(
                              "v-btn",
                              {
                                attrs: { color: "secondary", text: "" },
                                on: {
                                  click: function($event) {
                                    _vm.reportDialog = false
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  "\n                                Close\n                            "
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "v-btn",
                              {
                                attrs: { color: "primary", text: "" },
                                on: {
                                  click: function($event) {
                                    return _vm.loadQC_Report()
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  "\n                                Load\n                            "
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "v-btn",
                              {
                                attrs: { color: "accent", text: "" },
                                on: {
                                  click: function($event) {
                                    return _vm.deleteQC_DialogHandler()
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  "\n                                Delete\n                            "
                                )
                              ]
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c(
        "v-app",
        { attrs: { id: "inspire" } },
        [
          _c(
            "v-row",
            { attrs: { justify: "center" } },
            [
              _c(
                "v-dialog",
                {
                  attrs: { persistent: "", "max-width": "290" },
                  model: {
                    value: _vm.deleteDialog,
                    callback: function($$v) {
                      _vm.deleteDialog = $$v
                    },
                    expression: "deleteDialog"
                  }
                },
                [
                  _c(
                    "v-card",
                    [
                      _c("v-card-title", { staticClass: "text-h6" }, [
                        _vm._v(
                          "\n\t\t\t\t\t\tAre you sure you want to delete?\n\t\t\t\t\t"
                        )
                      ]),
                      _vm._v(" "),
                      _c(
                        "v-card-actions",
                        [
                          _c("v-spacer"),
                          _vm._v(" "),
                          _c(
                            "v-btn",
                            {
                              attrs: { color: "secondary", text: "" },
                              on: {
                                click: function($event) {
                                  _vm.deleteDialog = false
                                }
                              }
                            },
                            [_vm._v("\n\t\t\t\t\t\tCancel\n\t\t\t\t\t\t")]
                          ),
                          _vm._v(" "),
                          _c(
                            "v-btn",
                            {
                              attrs: { color: "primary", text: "" },
                              on: {
                                click: function($event) {
                                  return _vm.deleteQC_Report()
                                }
                              }
                            },
                            [_vm._v("\n\t\t\t\t\t\tOK\n\t\t\t\t\t\t")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("ul", { staticClass: "sidebar-nav" }, [
      _c("li", { staticClass: "d-block mb-1 has-text-weight-semibold" }, [
        _vm._v("Gel Image upload")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "ul",
      { staticClass: "sidebar-nav", staticStyle: { "margin-top": "10px" } },
      [
        _c("li", { staticClass: "d-block mb-1 has-text-weight-semibold" }, [
          _vm._v("NanoDrop Image upload")
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("ul", { staticClass: "sidebar-nav" }, [
      _c("li", { staticClass: "d-block mb-1 has-text-weight-semibold" }, [
        _vm._v("TapeStation Upload")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("ul", { staticClass: "sidebar-nav" }, [
      _c("li", { staticClass: "d-block mb-1 has-text-weight-semibold" }, [
        _vm._v("BioAnalyzer Upload")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "ul",
      { staticClass: "sidebar-nav", staticStyle: { "margin-top": "10px" } },
      [
        _c("li", { staticClass: "d-block mb-1 has-text-weight-semibold" }, [
          _vm._v("Report upload")
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", { staticClass: "nav-item" }, [
      _c(
        "a",
        {
          staticClass: "nav-link",
          attrs: {
            id: "samples-tab",
            "data-toggle": "tab",
            href: "#samples",
            role: "tab",
            "aria-controls": "samples",
            "aria-selected": "false"
          }
        },
        [_vm._v("Samples")]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "chart-three clearfix" }, [
      _c("div", {
        staticClass: "flot-chart ht-30",
        attrs: { id: "flotChart5" }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "view-cart" }, [
        _c(
          "span",
          {
            staticClass: "close-cart",
            attrs: { "data-toggle": "collapse", "data-target": "#ViewGel" }
          },
          [_vm._v("Close")]
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "chart-three clearfix" }, [
      _c("div", {
        staticClass: "flot-chart ht-30",
        attrs: { id: "flotChart5" }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "view-cart" }, [
        _c(
          "span",
          {
            staticClass: "close-cart",
            attrs: { "data-toggle": "collapse", "data-target": "#ViewNano" }
          },
          [_vm._v("Close")]
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "chart-three clearfix" }, [
      _c("div", {
        staticClass: "flot-chart ht-30",
        attrs: { id: "flotChart5" }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "chart-three clearfix" }, [
      _c("div", {
        staticClass: "flot-chart ht-30",
        attrs: { id: "flotChart5" }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "view-cart" }, [
        _c(
          "span",
          {
            staticClass: "close-cart",
            attrs: { "data-toggle": "collapse", "data-target": "#ViewTape" }
          },
          [_vm._v("Close")]
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "chart-three clearfix" }, [
      _c("div", {
        staticClass: "flot-chart ht-30",
        attrs: { id: "flotChart5" }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "chart-three clearfix" }, [
      _c("div", {
        staticClass: "flot-chart ht-30",
        attrs: { id: "flotChart5" }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "view-cart" }, [
        _c(
          "span",
          {
            staticClass: "close-cart",
            attrs: { "data-toggle": "collapse", "data-target": "#ViewBio" }
          },
          [_vm._v("Close")]
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "modal-header" }, [
      _c(
        "h6",
        { staticClass: "modal-title", attrs: { id: "exampleModalLabel5" } },
        [_vm._v("Chat")]
      ),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "close",
          attrs: {
            type: "button",
            "data-dismiss": "modal",
            "aria-label": "Close"
          }
        },
        [_c("span", { attrs: { "aria-hidden": "true" } }, [_vm._v("×")])]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "modal-header" }, [
      _c(
        "h6",
        { staticClass: "modal-title", attrs: { id: "exampleModalLabel6" } },
        [_vm._v("Sample Division")]
      ),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "close",
          attrs: {
            type: "button",
            "data-dismiss": "modal",
            "aria-label": "Close"
          }
        },
        [_c("span", { attrs: { "aria-hidden": "true" } }, [_vm._v("×")])]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "modal-body" }, [
      _c("p", { staticClass: "mg-b-0" }, [
        _vm._v("Please enter the number of samples to division.")
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "mg-b-0" }, [_vm._v(" ")]),
      _vm._v(" "),
      _c("p", { staticClass: "mg-b-0" }, [
        _c("input", {
          staticClass: "form-control",
          attrs: { type: "number", min: "1", max: "100", id: "addNum" }
        })
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d85a6e46", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d85a6e46","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Experiment/DetailForm.vue
// module id = null
// module chunks = 